import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../AppIcon";
import { useLanguage } from "hooks/useLanguage";
import { cn } from "utils/cn";

const LanguageSwitcher = ({ className = "" }) => {
  const { t } = useTranslation("common");
  const { language, languages, currentLanguage, changeLanguage } = useLanguage();

  return (
    <div
      className={cn("rounded-lg", className)}
      role="group"
      aria-label={t("language.ariaLabel", {
        language: currentLanguage.label,
      })}
    >
      <div className="flex items-center justify-between gap-3 px-3 py-2">
        <span className="flex items-center text-sm font-medium text-popover-foreground">
          <Icon name="Languages" size={16} className="me-3 flex-shrink-0" />
          {t("language.label")}
        </span>
        <span className="text-xs text-muted-foreground">
          {currentLanguage.label}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-1 px-2 pb-2">
        {languages.map((option) => {
          const isActive = option.code === language;

          return (
            <button
              key={option.code}
              type="button"
              aria-pressed={isActive}
              aria-label={t("language.switchTo", {
                language: option.label,
              })}
              onClick={() => changeLanguage(option.code)}
              className={cn(
                "min-h-9 rounded-md px-2 text-sm font-medium transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
                isActive
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "text-muted-foreground hover:bg-muted/80 hover:text-foreground",
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
